import customerPinIcon from './images/customer.png';
import restaurantPinIcon from './images/restaurant.png';
import riderPinIcon from './images/rider-default.png';
import riderCarPinIcon from './images/rider-car.png';
import riderCyclistPinIcon from './images/rider-cyclist.png';
import riderScooterPinIcon from './images/rider-scooter.png';
import riderWalkerPinIcon from './images/rider-walker.png';

const riderPinOptions = {
  anchor: [24, 24],
  size: [148, 148],
  scaledSize: [49, 49],
};

export default {
  CUSTOMER: {
    url: customerPinIcon,
    anchor: [22, 52],
    size: [132, 186],
    scaledSize: [44, 62],
  },
  RESTAURANT: {
    url: restaurantPinIcon,
    anchor: [22, 52],
    size: [132, 186],
    scaledSize: [44, 62],
  },
  RIDER_DEFAULT: {
    ...riderPinOptions,
    url: riderPinIcon,
  },
  RIDER_CAR: {
    ...riderPinOptions,
    url: riderCarPinIcon,
  },
  RIDER_CYCLIST: {
    ...riderPinOptions,
    url: riderCyclistPinIcon,
  },
  RIDER_SCOOTER: {
    ...riderPinOptions,
    url: riderScooterPinIcon,
  },
  RIDER_WALKER: {
    ...riderPinOptions,
    url: riderWalkerPinIcon,
  },
};
